// extracted by mini-css-extract-plugin
module.exports = {"newsletterDialog":"NewsletterSubscriptionDialog_newsletterDialog__l44yn","loaded":"NewsletterSubscriptionDialog_loaded__QaJ7w"};